// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getConfOpinometro as getConfOpinometroAPI,
    updateConfOpinometro as updateConfOpinometroAPI,
} from '../../helpers/';

import { confOpinometroApiResponseError, confOpinometroApiResponseSuccess } from './actions';
import { ConfOpinometroActionTypes } from './constants';


/**
 * Get confOpinometro
 * @param {*} payload - username and password
 */
function* getConfOpinometro({ payload: { confOpinometroId, destination } }) {
    try {
        const response = yield call(getConfOpinometroAPI, confOpinometroId, destination);
        const confOpinometro = response.data.data;
        yield put(confOpinometroApiResponseSuccess(ConfOpinometroActionTypes.GET_CONF_OPINOMETRO, confOpinometro));
    } catch (error) {
        yield put(confOpinometroApiResponseError(ConfOpinometroActionTypes.GET_CONF_OPINOMETRO, error));
    }
}

function* updateConfOpinometro({ payload: confOpinometro }) {
    try {
        const response = yield call(updateConfOpinometroAPI, { ...confOpinometro })
        const confOpinometroItem = response.data.data
        yield put(confOpinometroApiResponseSuccess(ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO, confOpinometroItem))
    } catch (error) {
        yield put(confOpinometroApiResponseError(ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO, error))
    }
}

export function* watchGetConfOpinometro(): any {
    yield takeEvery(ConfOpinometroActionTypes.GET_CONF_OPINOMETRO, getConfOpinometro);
}

export function* watchUpdateConfOpinometro(): any {
    yield takeEvery(ConfOpinometroActionTypes.UPDATE_CONF_OPINOMETRO, updateConfOpinometro)
}

function* confOpinometroSaga(): any {
    yield all([
        fork(watchGetConfOpinometro),
        fork(watchUpdateConfOpinometro)
    ]);
}

export default confOpinometroSaga;
